import { DateTime } from 'luxon';

export const TODAY = DateTime.utc().startOf('day');
